import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

export const getSingleQuestions = createAsyncThunk(
  "getSingleQuestions",
  async (params, { rejectWithValue }) => {
    try {
      const token = params?.token;
      const surveyId = params?.surveyId;
      // const sectionId = params?.sectionId;
      const questionId = params?.questionId;
      const urls = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_PREFIX_URL}${surveyId}/question/${questionId}/`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(urls, { headers });
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

/*process.env.REACT_APP_BASE_URL +
        process.env.REACT_APP_PREFIX_URL +
        `${surveyId}/question/${questionId}/`,*/
export const getSingleQuestionSlice = createSlice({
  name: "getSingleQuestion",
  initialState,
  reducers: {
    clearData(state) {
      state.data = [];
      state.error = "";
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSingleQuestions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleQuestions.fulfilled, (state, action) => {
      // console.log('Get single Question data:', action.payload);
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(getSingleQuestions.rejected, (state, action) => {
      state.loading = false;
      state.data = [];
      state.error = action.error.message;
    });
  },
});
export const { clearData, setLoading } = getSingleQuestionSlice.actions;
export default getSingleQuestionSlice.reducer;
